"use client";

import Core from "@/components/core";
import { usePathname } from "next/navigation";
import { useFetchNewsData } from "@/hooks/fetchNewsData";
import { useState, useEffect, Suspense } from "react";
import LoadingSkeleton from "@/app/loading";
import styles from "@/app/layanan/[...slug]/detailLayanan.module.css";

const DetailNews = () => {
  const [isLoading, setIsLoading] = useState(true);
  const pathname = usePathname();
  const slug = pathname.split("/").filter(Boolean).pop() ?? "";

  const detailNews = useFetchNewsData(slug);
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const cleanHtml = (html: string) => {
    return html.replace(/\\n/g, "");
  };

  return (
    <>
      <div className="lg:p-6 md:p-2.5 p-2 rounded-md shadow">
        <Suspense fallback={<LoadingSkeleton />}>
          {isLoading ? (
            <LoadingSkeleton />
          ) : (
            detailNews?.status === 200 &&
            detailNews?.data?.map((item: any) => (
              <Core.DetailArticles
                key={item.id}
                title={item.title}
                alt={item.title}
                content={
                  <div
                    className={styles.contentContainer}
                    dangerouslySetInnerHTML={{
                      __html: cleanHtml(item.content),
                    }}
                  />
                }
                image={`https://admin.macspace.id/public/${item.image}`}
                author_image={`https://admin.macspace.id/public/${item.user.image}`}
                author={item.user.name}
                created_at={formatDate(item.created_at)}
              />
            ))
          )}
        </Suspense>
      </div>
    </>
  );
};

export default DetailNews;
